<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>{{tab_name}}</span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'" matTooltipPosition="above"></i>
        </button>
      </div>
      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>

    <button *ngIf="mode === 'custom'" class="btn peer-group-selector-btn"
      (click)="openUniverseSelector()">
      <i class="bi bi-funnel"></i> Peer Group Selection
    </button>
  </div>

  <div class="row">
    <div class="col m-10" style="margin:20px;">
      <div style="margin-bottom:10px;">{{ modeDescription }}</div>

      <div class="card keywords" style="padding:20px;"
        *ngIf="modeFilteredCompanies.length > 0 || showSpinner || showDataMissing || loadingFailed">

        <h3>Top Companies in Theme</h3>

        <app-loading-progress
          [active]="showSpinner"
          title="Loading top companies"
          [stages]="LOADING_STAGES"
          [estimateSeconds]="30"
          [trackingKey]="tabId + ':competitors:' + mode"
          hint="Broad themes take longer to compute.">
        </app-loading-progress>

        <div class="alert alert-danger" role="alert" *ngIf="loadingFailed">
          <p>
            Unfortunately, we weren't able to load the top companies. Please try again later, or for more assistance,
            please contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>

        <div class="empty-state" *ngIf="showDataMissing">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Companies Found</h4>
            <p>No companies were found based on your current peer group selection in this theme. You can try adjusting
              your filters, such as market cap range or public companies or private companies, to broaden the search.</p>
          </div>
        </div>

        <!-- Category Tabs -->
        <div class="category-tabs" *ngIf="modeFilteredCompanies.length > 0 && !loadingFailed">
          <div class="tab-buttons">
            <button *ngFor="let category of categoryTabs" class="category-tab-btn"
              [class.active]="selectedCategory === category.key" (click)="selectCategory(category.key)">
              {{ category.label }}
            </button>
          </div>
          <div class="category-description" *ngIf="getCurrentCategoryDescription()">
            <p>
              {{ getCurrentCategoryDescription() }}
              <i class="bi bi-info-circle" [matTooltip]="getCurrentCategoryTooltip()" matTooltipPosition="above"
                style="margin-left: 8px; cursor: pointer;"></i>
            </p>
          </div>
        </div>

        <!-- Filters -->
        <div class="filters" *ngIf="modeFilteredCompanies.length > 0 && !loadingFailed">
          <mat-slide-toggle (change)="filterFavorites()">
            Show <i class="bi bi-star"></i> Selection Only
          </mat-slide-toggle>

          <div class="search-container">
            <input type="text" class="form-control" placeholder="Search by Company Name" [(ngModel)]="searchQuery"
              (input)="onSearchInputChange($event)">
            <div class="search-spinner" *ngIf="isSearching">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Searching...</span>
              </div>
            </div>
            <button *ngIf="searchQuery && !isSearching" (click)="clearSearch()" class="clear-search-btn">
              <i class="bi bi-x-circle"></i>
            </button>
          </div>

          <button  *ngIf="mode !== 'private'" class="btn add-selection-to-watchlist-button"
            [disabled]="getSelectedEligibleCompanies().length === 0" (click)="openAddToWatchlist()">
            <i class="bi bi-bookmark-plus"></i>
            Add Selection to Watchlist
          </button>

          <button class="btn download-button" (click)="downloadExcel()" matTooltip="Download Excel">
            <i class="bi bi-download"></i>
          </button>
        </div>

        <!-- Table -->
        <table class="table table-hover table-condensed"
          *ngIf="modeFilteredCompanies.length > 0 && !loadingFailed">
          <thead>
            <tr style="background-color: #96c242;">
              <th scope="col" style="width: 5%;">Select</th>
              <th scope="col" style="width: 5%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank')">
                Rank
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('rank')"></i>
              </th>
              <th scope="col" style="width: 20%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='company' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('company')">
                Company
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('company')"></i>
              </th>
              <th scope="col" style="width: 10%;">
                <div class="dropdown" style="font-weight:normal;">
                  <button class="btn country-dropdown-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 14px;">
                    Country / <br>Market
                    <span *ngIf="(countriesControl.value?.length ?? 0) > 0" class="badge bg-light text-dark ms-1">
                      {{ countriesControl.value!.length }}
                    </span>
                  </button>
                  <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton"
                    style="width: 270px; max-height: 300px; overflow-y: auto;">
                    <div *ngFor="let region of countryFilterOptions">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <input type="checkbox" [checked]="isRegionFullySelected(region)"
                            (change)="toggleRegionSelection(region)" id="{{ region.region }}-region-checkbox"
                            class="form-check-input me-2">
                          <label for="{{ region.region }}-region-checkbox" class="form-check-label">
                            {{ region.region }}
                          </label>
                        </div>
                        <button class="btn btn-sm btn-light"
                          (click)="toggleExpand(region.region); $event.stopPropagation();">
                          <i class="bi"
                            [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>
                      </div>
                      <div *ngIf="isExpanded(region.region)" class="ms-3">
                        <div *ngFor="let country of region.countries" class="form-check">
                          <input type="checkbox" class="form-check-input" [id]="'country-' + country.code"
                            [checked]="(countriesControl.value ?? []).includes(country.code)"
                            (change)="toggleCountrySelection(country.code)">
                          <label class="form-check-label" [for]="'country-' + country.code">
                            {{ country.name }}
                          </label>
                        </div>
                      </div>
                      <hr class="my-2"
                        *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
                    </div>
                  </div>
                </div>
              </th>

              <th scope="col" style="width: 7%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('size')"
                [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}">
                In Theme Size (10y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme Invention Count (10y). Number of inventions filed by the company or its subsidiaries, published in the last 120 months, related to the selected technology. Quantifies the total size of IP assets of the company in this technology.'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('size')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'size_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th scope="col" style="width: 12%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('growth')"
                [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}">
                Growth (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme % Change, 1y. Percentage value showing how the innovation activity in the last year compares to the previous year in the technology. Quantifies the increase or decrease in the company\'s innovation efforts into this technology. Values in parentheses show the number of inventions published in the last 12 months.'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('growth')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'growth_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th scope="col" style="width: 8%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('quality')"
                [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}">
                Quality (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme, 0-100, 1y. Quant IP Quality Score is a proprietary metric to evaluate the quality of an invention upon first publication. Taking into account robustness, market potential, and citation potential, a larger average score at a company level indicates a higher patent portfolio value.'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('quality')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'quality_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th style="width: 7%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='exposure' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('exposure')">
                Exposure
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-theme exposure: share of the company\'s 10-year inventions related to this technology (in-theme count / total count over 120m).'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('exposure')"></i>
              </th>

              <th style="width: 7%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='total_size_10y' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('total_size_10y')">
                Total Size (10y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Number of inventions filed by the company or its subsidiaries across all technologies in the last 120 months.'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('total_size_10y')"></i>
              </th>

              <th style="width: 15%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('innovation_score')"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                Innovation Score (0-100, 1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'The innovation score is a combinatorial score used for comparing the innovative strength of companies to their competitors. It takes size, growth, and quality into account and is normalized based on the peer group.'"
                  matTooltipPosition="above"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('innovation_score')"></i>
                <i class="bi bi-caret-down-fill"
                  *ngIf="selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th style="width: 11%;">Action</th>
            </tr>
          </thead>
          <tbody>
            <!-- Empty category state -->
            <tr *ngIf="!hasCategoryResults()">
              <td colspan="12" style="white-space: normal; overflow: visible; background: transparent; padding: 0;">
                <div class="empty-state">
                  <div class="empty-state-content">
                    <i class="bi bi-funnel empty-state-icon"></i>
                    <h4>No Companies Match</h4>
                    <p>No companies match the criteria for <b>{{ getCurrentCategoryLabel() }}</b> in the current peer
                      group. Try selecting a different category or adjusting your filters.</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr
              *ngFor="let company of filteredCompanyList | paginate: {id: paginationId, itemsPerPage: 20, currentPage: paginator_1_page}">
              <td>
                <div class="action-cell">
                  <button (click)="toggleCompanySelection(company)" class="btn btn-light action-star-btn"
                    [class.selected]="isCompanySelected(company.entityid)"
                    [matTooltip]="isCompanySelected(company.entityid) ? 'Deselect' : 'Select'">
                    <i class="bi"
                      [ngClass]="isCompanySelected(company.entityid) ? 'bi-star-fill text-warning' : (company.favorite ? 'bi-star-fill text-warning' : 'bi-star')"></i>
                  </button>
                </div>
              </td>
              <td style="width: 70px;"
                [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'">
                {{ company.rank }}
              </td>
              <td [class.sorted-col]="sortColumn==='company' && selectedCategory === 'all_competitors'">
                <div class="text"
                  style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  matTooltip="{{company.entity_name}}">
                  {{ company.entity_name }}
                </div>
                <div class="isin" *ngIf="company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.isin}}
                  <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
                <div class="isin" *ngIf="!company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.companytype}}
                  <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </td>
              <td>{{company.country}}</td>
              <td [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'"
                [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}">
                {{ company.in_theme_invention_count_120m | nullableNumber:'1.0-0' }}
              </td>
              <td [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'"
                [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}">
                <div>{{ company.relative_growth_12m | nullableNumber:'1.0-1' }} %</div>
                <div style="font-size: 12px;color: cadetblue;">
                  ({{ company.invention_count_12m | nullableNumber:'1.0-0' }} inventions)
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'"
                [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}">
                {{company.quality_average_12m | nullableNumber:'1.0-1' }}
              </td>
              <td
                [class.sorted-col]="sortColumn==='exposure' && selectedCategory === 'all_competitors'">
                {{ company.exposure | nullableNumber:'1.0-1' }} %
              </td>
              <td
                [class.sorted-col]="sortColumn==='total_size_10y' && selectedCategory === 'all_competitors'">
                {{company.all_invention_count_120m | nullableNumber:'1.0-0'}}
              </td>
              <td [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                <div class="score-bar-container">
                  <div class="score-bar">
                    <div class="score-bar-fill" [style.background-color]="getBarColor(company.innovation_score)"
                      [style.width.%]="company.innovation_score"></div>
                  </div>
                  <span class="score-label">{{ company.innovation_score | nullableNumber:'1.0-1' }}</span>
                </div>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="btn action-btn" (click)="openCompanyPopup(company)"
                    matTooltip="View Company Details">
                    <i class="bi bi-search"></i>
                  </button>
                  <button class="btn action-btn" (click)="newSearch(company)"
                    matTooltip="Open Company in New Tab">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <pagination-controls [id]="paginationId" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          style="align-items: flex-start;" *ngIf="hasCategoryResults()">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>
